import { useRender } from '@base-ui/react/use-render'

import { cn } from '../../../../lib/utils.ts'

export function ItemContent(props: ItemContent.Props) {
  const { className, ref, ...rest } = props
  return useRender({
    ref,
    defaultTagName: 'span',
    props: { 'data-slot': 'item-content', className: cn('flex min-w-0 flex-1 flex-col gap-20', className), ...rest },
  })
}
export namespace ItemContent {
  export type Props = React.ComponentProps<'span'>
}
